import React, { Component } from 'react';
import './styles.css';
import Header from './Header';

class SubmissionPopUpLayout extends Component {
	render() {
		return (
			<div className="submission-pop-up-layout">{this.props.children}</div>
		);
	}
}

Object.assign(SubmissionPopUpLayout, {
	Header
});

export default SubmissionPopUpLayout;
